// import "./new.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { useState, useEffect } from "react";
// import { roleInputs } from "../../formSource";
// import Select from "react-select";
// import { useNavigate } from "react-router-dom";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const RoleNew = ({ title }) => {
//   const [inputValues, setInputValues] = useState({});
//   const [notification, setNotification] = useState("");
//   const [subjectOptions, setSubjectOptions] = useState([]); // Initial options
//   const [selectedSubject, setSelectedSubject] = useState([]); // Selected options
//   const center_id = localStorage.getItem("center_id");
//   const [removedOptions, setRemovedOptions] = useState([]); // Track removed options
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Please Login first to access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const navigate = useNavigate();

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubjectSelectChange = (selectedOptions) => {
//     const newlySelectedValues = selectedOptions.map(
//       (selected) => selected.value
//     );

//     // Remove the newly selected values from removedOptions
//     const updatedRemovedOptions = removedOptions.filter(
//       (option) => !newlySelectedValues.includes(option.value)
//     );

//     // Add the newly deselected values back to removedOptions
//     const newlyDeselectedOptions = subjectOptions.filter(
//       (option) =>
//         !newlySelectedValues.includes(option.value) &&
//         !removedOptions.includes(option)
//     );

//     // Update state
//     setRemovedOptions(updatedRemovedOptions);
//     setSubjectOptions([...subjectOptions, ...newlyDeselectedOptions]);

//     // Update the selected options
//     setSelectedSubject(selectedOptions);
//   };

//   // Fetch subjects from the server
//   const fetchSubjects = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/rscreen_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       const namelist = data.data.map((item) => ({
//         value: item.id,
//         label: item.name,
//       }));

//       // Set the initial subject options (including the removed options if any)
//       setSubjectOptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       toast.error("Error fetching screen options.");
//     }
//   };

//   useEffect(() => {
//     fetchSubjects();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     const userValues = selectedSubject.map((option) => option.value);
//     formData.append("center_id", center_id);
//     formData.append("name", inputValues.name);
//     formData.append("screen_id", userValues);
//     formData.append("status", inputValues.status || 1);

//     try {
//       const response = await fetch(`${serverUrl}/add_role`, {
//         method: "POST",
//         body: formData,
//       });

//       const data = await response.json();
//       if (response.ok) {
//         toast.success("User Role has been added successfully!");

//         setInputValues({});
//         setSelectedSubject([]);
//         setSubjectOptions([]); // Reset subject options after success
//         fetchSubjects(); // Re-fetch subjects to re-populate the dropdown

//         setTimeout(() => {
//           navigate(`/role`);
//         }, 1000);
//       } else {
//         throw new Error(data.message || "Failed to add role.");
//       }
//     } catch (error) {
//       console.log(error);
//       toast.error("Error occurred. Please try again.");
//       setInputValues({});
//       setSelectedSubject([]);
//       fetchSubjects(); // Re-fetch subjects in case of error
//     }
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="right">
//                 <form onSubmit={handleSubmit}>
//                   {roleInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       {input.fieldName === "status" ? null : (
//                         <>
//                           <label>{input.label}</label>
//                           {input.fieldName === "screen_id" ? (
//                             <Select
//                               options={subjectOptions}
//                               name={input.fieldName}
//                               isMulti
//                               value={selectedSubject}
//                               onChange={handleSubjectSelectChange}
//                               required
//                             />
//                           ) : (
//                             <input
//                               type={input.type}
//                               placeholder={input.placeholder}
//                               name={input.fieldName}
//                               onChange={handleInputChange}
//                               required
//                             />
//                           )}
//                         </>
//                       )}
//                     </div>
//                   ))}
//                   <div className="formSubmit">
//                     <button type="submit">Send</button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default RoleNew;

import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState, useEffect } from "react";
import { roleInputs } from "../../formSource";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const RoleNew = ({ title }) => {
  const [inputValues, setInputValues] = useState({});
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const center_id = localStorage.getItem("center_id");
  let [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please Login first to access this page...");
    window.location.href = "/";
  };

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubjectSelectChange = (selectedOptions) => {
    const newlySelectedValues = selectedOptions.map(
      (selected) => selected.value
    );
    const updatedRemovedOptions = subjectOptions.filter(
      (option) => !newlySelectedValues.includes(option.value)
    );
    const newlyDeselectedOptions = subjectOptions.filter(
      (option) =>
        !newlySelectedValues.includes(option.value) &&
        !updatedRemovedOptions.includes(option)
    );
    setSubjectOptions([...subjectOptions, ...newlyDeselectedOptions]);
    setSelectedSubject(selectedOptions);
  };

  const fetchSubjects = async () => {
    try {
      const response = await fetch(`${serverUrl}/rscreen_ids`);
      if (!response.ok) {
        throw new Error("Failed to fetch data from the API");
      }
      const data = await response.json();
      const namelist = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setSubjectOptions(namelist);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Error fetching screen options.");
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    const userValues = selectedSubject.map((option) => option.value);
    // formData.append("center_id", localStorage.getItem("center_id"));
    formData.append("name", inputValues.name);
    formData.append("screen_id", userValues);
    formData.append("status", inputValues.status || 1);

    try {
      const response = await fetch(`${serverUrl}/add_role`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        toast.success("User Role has been added successfully!");
        setInputValues({});
        setSelectedSubject([]);
        setSubjectOptions([]);
        fetchSubjects();
        setTimeout(() => {
          navigate(`/role`);
        }, 1000);
      } else {
        throw new Error(data.message || "Failed to add role.");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error occurred. Please try again.");
      setInputValues({});
      setSelectedSubject([]);
      fetchSubjects();
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      {roleInputs.map((input) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          key={input.id}
                          className="formGridItem"
                        >
                          <div className="formInput">
                            {input.fieldName == "status" ? null : (
                              <>
                                <label>{input.label}</label>
                                {input.fieldName === "screen_id" ? (
                                  <Select
                                    options={subjectOptions}
                                    name={input.fieldName}
                                    isMulti
                                    value={selectedSubject}
                                    onChange={handleSubjectSelectChange}
                                    required
                                    className="selectInput"
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        minHeight: "46px",
                                        borderColor: "#e2e8f0",
                                        "&:hover": {
                                          borderColor: "#cbd5e0",
                                        },
                                      }),
                                      valueContainer: (base) => ({
                                        ...base,
                                        padding: "2px 8px",
                                      }),
                                      input: (base) => ({
                                        ...base,
                                        margin: "0",
                                        padding: "0",
                                      }),
                                      indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "44px",
                                      }),
                                    }}
                                  />
                                ) : (
                                  <input
                                    type={input.type}
                                    placeholder={input.placeholder}
                                    name={input.fieldName}
                                    onChange={handleInputChange}
                                    required
                                  />
                                )}
                              </>
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/role")}
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                      >
                        Create Role
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default RoleNew;
